import { render, staticRenderFns } from "./CustomerBillDetail.vue?vue&type=template&id=2e64845b"
import script from "./CustomerBillDetail.vue?vue&type=script&lang=js"
export * from "./CustomerBillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports